import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import Pagination from "../General/Pagination";
import FeeSystemMenu from "./FeeSystemMenu";
import BanksDropDown from "../Shared/BanksDropDown";
import { scrollToTop } from "../Shared/ScrollOnTop";
import csvDownload from "json-to-csv-export";


function CollectionReportHeadWise(props) {
    const showImportFeeDefaulter = false;
    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(
        localStorage.getItem("MemberType")
    );
    const grp_id = localStorage.getItem("User_Group_ID");

    const [loading, setLoading] = useState(false);
    const [totalDeposit, settotalDeposit] = useState("");
    const [StartDate, setStartDate] = useState(null);
    const [EndDate, setEndDate] = useState(null);

    const [ledger, setLedger] = useState([]);
    const [ledgerRecord, setLedgerRecord] = useState([]);
    const [showDateColumn, setShowDateColumn] = useState(true)
    const [hideZeroColumn, setHideZeroColumn] = useState(false)

    const [loaddata, setLoaddata] = useState(false)
    const [importFile, setImportFile] = useState(null);
    const [importLoading, setImportLoading] = useState(false);
    const [loadingDetailedExcel, setLoadingDetailedExcel] = useState(false);

    let totalReceipts = 0;

    // pagination
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [BenchNo, setBenchNo] = useState(0);
    const [BankID, setBankID] = useState(0);


    useEffect(() => {
        document.title = "Collection Report Headwise";
        if (StartDate == null || EndDate == null) {
            return;
        }
        setLoading(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            StartDate: StartDate,
            EndDate: EndDate,
            pageNo: pageNo,
            pageSize: pageSize,
            BenchNo: BenchNo,
            BusRouteID: BankID,
            AddTransportFee: hideZeroColumn
        };

        var api_config = {
            method: "post",
            url: config.base_url + "FeeSystem/GetCollectionReportHeadWise",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };
        ////console.log(data)
        axios(api_config)
            .then(function (response) {
                //console.log(response.data);
                if (response.data.status_code == 1) {
                    setLedger(response.data.ListofRecords);
                    setTotalRecords(response.data.totalRecords);
                    settotalDeposit(response.data.TotalReceived);
                }
                else {
                    setLedger([]);
                    setTotalRecords(0);
                    settotalDeposit(0);
                }

                setLoading(false);
            })
            .catch(function (error) {

            });
    }, [pageNo, pageSize]);

    const renderLedger = () => {
        if (ledger.length > 0) {
            return ledger.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.FeeCode}</td>
                        <td>{item.Fee_Type_Name}</td>
                        <td>{item.StudentCount}</td>
                        <td>{item.TotalReceived}</td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="5">
                        <h4
                            className="mt-3"
                            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
                        >
                            No Data Found
                        </h4>
                    </td>
                </tr>
            );
        }
    };

    const GetReport = () => {
        if (StartDate == null || EndDate == null) {
            return;
        }
        setLoading(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            StartDate: StartDate,
            EndDate: EndDate,
            pageNo: pageNo,
            pageSize: pageSize,
            BenchNo: BenchNo,
            BusRouteID: BankID,
            AddTransportFee: hideZeroColumn
        };

        var api_config = {
            method: "post",
            url: config.base_url + "FeeSystem/GetCollectionReportHeadWise",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };
        //console.log(data)
        axios(api_config)
            .then(function (response) {
                // console.log(response.data);
                if (response.data.status_code == 1) {
                    setLedger(response.data.ListofRecords);
                    setTotalRecords(response.data.totalRecords);
                    settotalDeposit(response.data.TotalReceived);
                }
                else {
                    setLedger([]);
                    setTotalRecords(0);
                    settotalDeposit(0);
                }

                setLoading(false);
            })
            .catch(function (error) {
                toast.error("Network Error..", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                //console.error(error);
            });
    };
    const handlePageChange = (page) => {
        setPageNo(page);
    };

    const deleteScrollEntry = (ID) => {
        const confirm = window.confirm("Are you sure you want to proceed ?");
        if (confirm) {
            setLoading(true);
            const data = {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                Entry_Id: ID,
            };
            ////console.log(data)
            var api_config = {
                method: "post",
                url: config.base_url + "ScrollEntry/DeleteScrollEntry",
                headers: {
                    "Content-Type": "application/json",
                },
                data: data,
            };
            axios(api_config)
                .then(function (response) {
                    // console.log(response.data);
                    if (response.data.status_code == 1) {
                        toast.success(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        GetReport()
                        setLoading(false);
                    }
                    else {
                        setLoading(false);
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                    // setIsUpdated(false);
                })
                .catch(function (error) {
                    //////console.log(error);
                    setLoading(false);
                });
        }
    };

    let count = 0;
    const listOfLedgerNew = ledgerRecord.map(({ ...rest }) => ({
        ...rest,
    }));

 

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            try {
                if (!file) {
                    reject(new Error("No file provided"));
                    return;
                }
                
                const reader = new FileReader();
                reader.onload = () => {
                    if (reader.result) {
                        resolve(reader.result);
                    } else {
                        reject(new Error("Failed to read file"));
                    }
                };
                reader.onerror = (error) => {
                    reject(new Error("Error reading file: " + (error?.message || "Unknown error")));
                };
                reader.readAsDataURL(file);
            } catch (error) {
                reject(new Error("Error converting file to base64: " + (error?.message || "Unknown error")));
            }
        });
    };

    const handleImportFeeDefaulter = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        // Prevent multiple simultaneous imports
        if (importLoading) {
            return;
        }

        if (!importFile) {
            toast.error("Please select a CSV file to upload", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        // Validate file type
        const fileTypes = ["text/csv", "application/vnd.ms-excel"];
        if (!fileTypes.includes(importFile.type) && !importFile.name.toLowerCase().endsWith('.csv')) {
            toast.error("Please select only CSV file type", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        setImportLoading(true);

        try {
            const base64File = await convertToBase64(importFile);
            const fileName = importFile.name;

            // First, upload the file to the server
            const uploadData = {
                accessKey: AccessKey,
                userId: UserID,
                memberType: MemberType,
                fileContent: base64File,
                fileName: fileName,
            };

            var uploadConfig = {
                method: "post",
                url: config.base_url + "FeeSystem/ImportFeeDefaulterReportDirect",
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(uploadData),
            };

            axios(uploadConfig)
                .then(function (response) {
                    if (response.data.status_code == 1) {
                        toast.success(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 6000,
                        });
                        setImportFile(null);
                        // Reset file input
                        const fileInput = document.getElementById("feeDefaulterFile");
                        if (fileInput) {
                            fileInput.value = "";
                        }
                    } else {
                        toast.error(response.data.status_message || "Import failed", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 6000,
                        });
                    }
                    setImportLoading(false);
                })
                .catch(function (error) {
                    setImportLoading(false);
                    let errorMessage = "Unknown error occurred";
                    
                    if (error) {
                        if (error.response) {
                            // Server responded with error
                            errorMessage = error.response.data?.error_message || 
                                         error.response.data?.status_message || 
                                         error.response.statusText || 
                                         `Server error (${error.response.status})`;
                        } else if (error.request) {
                            // Request made but no response
                            errorMessage = "No response from server. Please check your connection.";
                        } else if (error.message) {
                            // Error in request setup
                            errorMessage = error.message;
                        } else if (typeof error === 'string') {
                            errorMessage = error;
                        } else {
                            errorMessage = error.toString() || JSON.stringify(error);
                        }
                    }
                    
                    console.error("Import API error:", error);
                    toast.error("Import Error: " + errorMessage, {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 6000,
                    });
                });
        } catch (error) {
            setImportLoading(false);
            let errorMsg = "Unknown error occurred";
            
            if (error) {
                if (typeof error === 'string') {
                    errorMsg = error;
                } else if (error.message) {
                    errorMsg = error.message;
                } else if (error.toString) {
                    errorMsg = error.toString();
                } else {
                    errorMsg = JSON.stringify(error);
                }
            }
            
            console.error("Import error:", error);
            toast.error("Error processing file: " + errorMsg, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 6000,
            });
        }
    };

    const handleSubmitForCvs = () => {
        setLoaddata(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            StartDate: StartDate,
            EndDate: EndDate,
            pageNo: 1,
            pageSize: 1000000000,
            BenchNo: BenchNo,
            BusRouteID: BankID,
            AddTransportFee: hideZeroColumn
        };
        ////console.log(data);

        var api_config = {
            method: "post",
            url: config.base_url + "FeeSystem/GetCollectionReportHeadWise",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };
        axios(api_config)
            .then(function (response) {
                //////console.log(response.data);
                setLedger(response.data.ListofRecords);
                let data = response.data.ListofRecords;
                let count = 1;
                const listOfLedgerNew = data.map(({ ...rest }) => ({
                    Serial_No: count++,
                    Fee_Code: rest.FeeCode,
                    Fee_Name: rest.Fee_Type_Name,
                    Students_Paid: rest.StudentCount,
                    Total_Amount: rest.TotalReceived,
                }));
                //   //////console.log(listOfLedgerNew);

                const dataToConvert = {
                    data: listOfLedgerNew,
                    filename: "CollectionReportHeadwise",
                    delimiter: ",",
                    headers: [
                        "Serial_No",
                        "Fee_Code",
                        "Fee_Name",
                        "Students_Paid",
                        "Total_Amount",
                    ],
                };

                csvDownload(dataToConvert);
                setLoaddata(false);
            })
            .catch(function (error) {
                //////console.log(error);
                setLoaddata(false);
            });
    }

    const handleDownloadDetailedExcel = () => {
        if (StartDate == null || EndDate == null) {
            toast.error("Please select date range first.", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        setLoadingDetailedExcel(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            StartDate: StartDate,
            EndDate: EndDate,
            BenchNo: BenchNo,
            BusRouteID: BankID,
            AddTransportFee: hideZeroColumn
        };

        var api_config = {
            method: "post",
            url: config.base_url + "FeeSystem/GetCollectionReportHeadWiseDetailed",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    const records = response.data.ListofRecords || [];
                    let feeTypes = response.data.FeeTypes || [];
                    if (records.length === 0) {
                        toast.error("There is no data available for download", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setLoadingDetailedExcel(false);
                        return;
                    }

                    if (hideZeroColumn) {
                        feeTypes = feeTypes.filter((ft) => {
                            let total = 0;
                            records.forEach((student) => {
                                const value = student[ft.Fee_Type_Name];
                                if (value !== undefined && value !== null && value !== "") {
                                    const num = Number(value);
                                    if (!Number.isNaN(num)) {
                                        total += num;
                                    }
                                }
                            });
                            return total !== 0;
                        });
                    }

                    const listOfLedgerNew = records.map((student, index) => {
                        const row = {
                            "Sr No": index + 1,
                            "Student Name": student.Student_Name || "",
                            "Father Name": student.Father_Name || "",
                            "Registration No": student.Registration_No || "",
                            "Bench Number": student.Bench_Number || 0,
                            "Class": student.Class || "",
                        };
                        feeTypes.forEach((ft) => {
                            row[ft.Fee_Type_Name] = student[ft.Fee_Type_Name] || 0;
                        });
                        row["Total Received"] = student.TotalReceived || 0;
                        return row;
                    });

                    const dataToConvert = {
                        data: listOfLedgerNew,
                        filename: "CollectionReportHeadwiseDetailed",
                        delimiter: ",",
                        headers: Object.keys(listOfLedgerNew[0] || {}),
                    };
                    csvDownload(dataToConvert);
                    setLoadingDetailedExcel(false);
                } else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setLoadingDetailedExcel(false);
                }
            })
            .catch(function (error) {
                toast.error("Network Error..", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLoadingDetailedExcel(false);
            });
    };

    return (
        <>
            <ToastContainer />

            <FeeSystemMenu />
            <div className="container body-content">
                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <NavLink to="/Dashboard">Dashboard</NavLink>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <NavLink to="/FeeSystem/FeeSystemDashboard">
                                                Fee System
                                            </NavLink>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Collection Report Headwise
                                        </li>
                                    </ol>
                                </nav>
                                <div className="page-title">Collection Report Headwise</div>
                            </div>
                            <div className="col-md-6">
                                <div className="page-right-actions">
                                    <a
                                        href="javascript:;"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFilteres"
                                        className="button button-white button-icon"
                                    >
                                        Filters
                                        <i className="ri-filter-3-line"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="collapse show" id="collapseFilteres">
                    <div className="page-content">
                        <div className="container">
                            {showImportFeeDefaulter && (
                                <div className="card mb-2">
                                    <div className="card-header">
                                        <h5 className="mb-0">
                                            <a
                                                href="javascript:;"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseImportDefaulter"
                                                className="text-decoration-none"
                                            >
                                                Import Fee Defaulter Report
                                                <i className="ri-arrow-down-s-line ms-2"></i>
                                            </a>
                                        </h5>
                                    </div>
                                    <div className="collapse" id="collapseImportDefaulter">
                                        <div className="card-body">
                                            <div className="row align-items-center">
                                                <div className="col-md-8">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="feeDefaulterFile" className="form-label">
                                                            Select Fee Defaulter CSV File:
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            type="file"
                                                            id="feeDefaulterFile"
                                                            onChange={(e) => setImportFile(e.target.files[0])}
                                                            accept=".csv"
                                                            required
                                                        />
                                                        <small className="form-text text-muted">
                                                            Please select the CSV file (Fee Defaulter Report 29-12-2025.csv) from the UploadExcel folder.
                                                            The file should have fee types in columns F to Z and admission numbers in column D.
                                                        </small>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 text-end">
                                                    <div className="form-group">
                                                        {importLoading ? (
                                                            <div className="d-flex align-items-center justify-content-end">
                                                                <Spinner
                                                                    animation="border"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    role="status"
                                                                />
                                                                <span>Importing...</span>
                                                            </div>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                onClick={handleImportFeeDefaulter}
                                                                className="button button-primary w-100"
                                                                disabled={!importFile}
                                                            >
                                                                <i className="ri-upload-cloud-2-line me-2"></i>
                                                                Import Defaulter Report
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="card mb-2">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Start Date :</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    onChange={(e) => setStartDate(e.target.value)}
                                                    max={moment().format(config.date_format_input)}
                                                    min={moment().subtract(4, 'months').format(config.date_format_input)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>End Date :</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    onChange={(e) => setEndDate(e.target.value)}
                                                    max={moment().format(config.date_format_input)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Bench No :</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    className="form-control"
                                                    placeholder="All"
                                                    value={BenchNo === 0 ? "" : BenchNo}
                                                    onChange={(e) => {
                                                        const v = e.target.value.trim();
                                                        setBenchNo(v === "" ? 0 : parseInt(v, 10) || 0);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Select Bank :</label>
                                                <select
                                                    name="WingId"
                                                    onChange={(e) => {
                                                        setBankID(parseInt(e.target.value, 10) || 0);
                                                    }}
                                                    className="form-select"
                                                >
                                                    <option value="0">---All---</option>
                                                    <BanksDropDown />
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3"></div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3"></div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3"></div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3"></div>
                                        </div>
                                        <div className="col-md-2 text-end">
                                            <lable>Hide Zero Columns</lable>
                                        </div>
                                        <div className="col-md-1  text-end">

                                            <div className="form-check text-end">

                                                <input
                                                    className="form-check-input"
                                                    checked={hideZeroColumn}
                                                    type="checkbox"
                                                    onChange={() => setHideZeroColumn(!hideZeroColumn)}
                                                />

                                            </div>
                                        </div>
                                        {
                                            loaddata ?
                                                <div className="col-md-1 text-center">
                                                    <div>
                                                        <div>
                                                            <Spinner
                                                                className="mt-4"
                                                                animation="border"
                                                                role="status"
                                                            ></Spinner>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="col-md-1 text-center"></div>
                                        }
                                        <div className="col-md-2 text-end">
                                            <div className="form-group text-end">
                                                <button
                                                    type="button"
                                                    onClick={GetReport}
                                                    className="button button-primary w-100"
                                                >
                                                    View Report
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-content">
                    <div className="container">
                        <div className="card">
                            <div className="card-body">
                                <table className="table table-theme">
                                    <thead>
                                        <tr>
                                            <th colSpan="5">{totalRecords} Records Found!</th>
                                        </tr>

                                        <tr>
                                            <th>Sr.No</th>
                                            <th>Fee Code</th>
                                            <th>Fee Name</th>
                                            <th>Students Paid</th>
                                            <th>Total Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td className="text-center" colSpan="5">
                                                    <Spinner animation="border" role="status"></Spinner>
                                                </td>
                                            </tr>
                                        ) : (
                                            <>{renderLedger()}</>
                                        )}
                                        <tr>
                                            <td colSpan={4}></td>
                                            <td>
                                                <b>{totalDeposit}</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                {totalRecords > 10 && (
                                    <div className="pagination-wrap">
                                        <div className="row align-items-center">
                                            <div className="col-md-2 form_default">
                                                <div className="d-flex align-items-center">
                                                    <label className="me-2" style={{ fontSize: "15px" }}>
                                                        Page Size
                                                    </label>
                                                    <div className="form-group">
                                                        <select
                                                            className="form-select"
                                                            style={{ width: "100px" }}
                                                            onChange={(e) => {
                                                                setPageNo(1);
                                                                setPageSize(parseInt(e.target.value));
                                                            }}
                                                        >
                                                            <option value="10" selected>
                                                                10
                                                            </option>
                                                            <option value="20">20</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="500">500</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <Pagination
                                                pageNo={pageNo}
                                                pageSize={pageSize}
                                                totalRecords={totalRecords}
                                                onPageChange={handlePageChange}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="card mt-2">
                            <div className="card-body">
                                <div className="row text-end align-items-center">


                                    <div className="col-md-2  ">
                                        {/* <lable>Show Date Column</lable> */}
                                    </div>

                                    <div className="col-md-1  text-end">

                                        {/* <div className="form-check ">

                      <input
                        className="form-check-input"
                        checked={showDateColumn}
                        type="checkbox"
                        onChange={() => setShowDateColumn(!showDateColumn)}
                      />

                    </div> */}
                                    </div>
                                    {/* {loaddata ?
                    <div className="col-md-2 ">
                      <div className="text-center" >
                        <Spinner animation="border" role="status"></Spinner>
                      </div>
                    </div>

                    : <div className="col-md-2 ">
                      <button
                        type="button"
                        className="button button-primary w-100"
                        onClick={handleDownload}
                      >
                        Download Data
                      </button>
                    </div>} */}
                                    <div className="col-md-2">
                                        {loadingDetailedExcel ? (
                                            <div className="text-center">
                                                <Spinner animation="border" role="status"></Spinner>
                                            </div>
                                        ) : (
                                            <button
                                                type="button"
                                                className="button button-primary w-100"
                                                onClick={handleDownloadDetailedExcel}
                                            >
                                                Download Detailed
                                            </button>
                                        )}
                                    </div>
                                    <div className="col-md-2 offset-2">

                                    </div>
                                    <div className="col-md-1  text-end">


                                    </div>


                                    <div className="col-md-2">
                                        <NavLink
                                            className={`button button-primary w-100 ${ledger.length == 0 ? "disabled" : ""
                                                }`}
                                            to={`/FeeSystem/PrintCollectionReport/?start=${StartDate}&end=${EndDate}`}
                                            target="_blank"
                                        >
                                            Print Report
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CollectionReportHeadWise;